<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Selma chair</h1>
          <figure class="image">
            <img src="static/images/selma/selma_01-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px">
          <p class="title">
            Selma chair’s design is a play between the sturdy wooden elements
            and the light seat and back surfaces supported by them.
          </p>
          <p>
            Selma chair’s design is a play between the sturdy wooden elements
            and the light seat and back surfaces supported by them. The
            considered details in the joints and the downwards-widening legs
            give the chair its character. The chair's elements connect at four
            key points, allowing for easy disassembly and flat-pack transport or
            storage.
          </p>
          <br />
          <p>
            With this, I wanted to consider the product’s carbon footprint and
            the online market. I aimed to solve the falling structure without
            compromising the ergonomics, functionality, or the chair’s
            aesthetics. The chair should also be convenient to make. The Selma
            chair is an honest and playful interpretation of a dining chair with
            a strong and recognizable character. The prototypes were crafted by
            local carpenters using locally sourced elm and ash.
          </p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/selma/selma_02-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/selma/selma_03-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/selma/selma_04-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/selma/selma_06-highres.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/selma/selma_05-highres.jpg" />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default')
  }
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Selma.vue